import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-operario',
  templateUrl: './content-operario.component.html',
  styleUrls: ['./content-operario.component.css']
})
export class ContentOperarioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
